export const unitApp = {
    sur:{
        0: "cm²",
        1: "m²",
        2: "km²",
        3: "ha",
        4: "in²",
        5: "ft²",
        6: "yd²"
    },
    dur:{
        0: "s",
        1: "mn",
        2: "H",
        3: "Day",
        4: "M",
        5: "Y"
    },
    sdist:{
        0: "mm",
        1: "cm",
        2: "in"
    },
    press:{
        0: "hPa",
        1: "kPa",
        2: "MPa",
        3: "bar",
        4: "psi"
    },
    mdist:{
        0: "cm",
        1: "dm",
        2: "m",
        3: "km",
        4: "in",
        5: "ft",
        6: "yd",
        7: "mile"
    },
    SperL:{
        0: "m²/l",
        1: "ft²/l",
        2: "ft²/gal-UK",
        3: "ft²/gal-US"
    },
    vol:{
        0:"dl",
        1:"L",
        2:"cm³",
        3:"m³",
        4:"in³",
        5:"ft³",
        6:"yd³",
        7:"gal (UK)",
        8:"gal (US)",
    },
    temp: {
        0: "C°",
        1: "F°",
        2: "K"
    },
    speed:{
        0:"km/h",
        1: "mph",
        2: "knot",
        3: "mach"
    },
    power:{
        0:"W",
        1:"KW",
        2:"MW",
        3:"HP",
        4:"ps",
        5:"kcal/s",
        6:"kcal/h"
    },
    lumen:{
        0:"Candéla",
        1:"Lumen",
        2:"Watts"
    },
    poids:{
        0:"g",
        1:"kg",
        2:"ton",
        3:"lb",
        4:"oz"
    }
}


// WEBPACK FOOTER //
// ./src/components/Protected/Travaux/unitApp.js